// extracted by mini-css-extract-plugin
export default {"button":"Tl-z","reviewSort":"Ul-z"};